export const listVehicleCartTypes = {
    POST_REQUEST: 'LISTVEHICLE_CART_POST_REQUEST',
    POST_SUCCESS: 'LISTVEHICLE_CART_POST_SUCCESS',
    POST_FAILURE: 'LISTVEHICLE_CART_POST_FAILURE',

    TOGGLE_CONFIRM: 'LISTVEHICLE_CART_TOGGLE_CONFIRM'
};
